export const isPositiveNumber = (num) => typeof num === 'number' && num > 0;
export const isNumericString = (str) => !Number.isNaN(str) && !Number.isNaN(parseFloat(str));
